import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbNavModule, NgbAccordionModule, NgbDropdownModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
// Swiper Slider
import { SlickCarouselModule } from 'ngx-slick-carousel';

// Counter
import { CountUpModule } from 'ngx-countup';

import { CurrencyInputDirective } from './directives/currency-input/currency-input.directive';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ClientLogoComponent } from './landing/index/client-logo/client-logo.component';
import { ServicesComponent } from './landing/index/services/services.component';
import { CollectionComponent } from './landing/index/collection/collection.component';
import { CtaComponent } from './landing/index/cta/cta.component';
import { DesignedComponent } from './landing/index/designed/designed.component';
import { PlanComponent } from './landing/index/plan/plan.component';
import { FaqsComponent } from './landing/index/faqs/faqs.component';
import { ReviewComponent } from './landing/index/review/review.component';
import { CounterComponent } from './landing/index/counter/counter.component';
import { WorkProcessComponent } from './landing/index/work-process/work-process.component';
import { TeamComponent } from './landing/index/team/team.component';
import { ContactComponent } from './landing/index/contact/contact.component';
import { FooterComponent } from './landing/index/footer/footer.component';
import { ScrollspyDirective } from './scrollspy.directive';
import { LandingScrollspyDirective } from './landingscrollspy.directive';

// NFT Landing
import { MarketPlaceComponent } from './landing/nft/market-place/market-place.component';
import { WalletComponent } from './landing/nft/wallet/wallet.component';
import { FeaturesComponent } from './landing/nft/features/features.component';
import { CategoriesComponent } from './landing/nft/categories/categories.component';
import { DiscoverComponent } from './landing/nft/discover/discover.component';
import { TopCreatorComponent } from './landing/nft/top-creator/top-creator.component';

// Job Landing
import { ProcessComponent } from './landing/job/process/process.component';
import { FindjobsComponent } from './landing/job/findjobs/findjobs.component';
import { CandidatesComponent } from './landing/job/candidates/candidates.component';
import { BlogComponent } from './landing/job/blog/blog.component';
import { JobcategoriesComponent } from './landing/job/jobcategories/jobcategories.component';
import { JobFooterComponent } from './landing/job/job-footer/job-footer.component';
import { WebExternalSanitizePipe } from './pipes/web-external-sanitize.pipe';
import { CurrencySymbolFormat } from './currency-symbol-format/currency-symbol-format.pipe';
import { ThousandDecimalFormat } from './currency-symbol-format/thousand-decimal-format.pipe';
import { MandatoryFieldFormLabelPipe } from './pipes/mandatory-field-form-label';
import { DistanceDescriptionPipe } from './pipes/distance-description.pipe';
import { DistancePipe } from './pipes/distance.pipe';
import { CurrencyCompactPipe } from './currency-symbol-format/currency-compact.pipe';
import { PhoneFormatterPipe } from './pipes/phone-formatter.pipe';
import { FlagPipe } from './pipes/flag.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { PaginatePipe } from './pipes/paginate.pipe';
import { SorterPipe } from './pipes/sorter.pipe';
import { TableCodePipe } from './pipes/table-code.pipe';
import { HasAccessDirective } from 'app/directives/access/has-access.directive';
import { ToTimezonePipe } from './pipes/to-timezone.pipe';
import { LineBreakAtPipe } from './pipes/line-break-at.pipe';



@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ClientLogoComponent,
    ServicesComponent,
    CollectionComponent,
    CtaComponent,
    DesignedComponent,
    PlanComponent,
    FaqsComponent,
    ReviewComponent,
    CounterComponent,
    WorkProcessComponent,
    TeamComponent,
    ContactComponent,
    FooterComponent,
    ScrollspyDirective,
    LandingScrollspyDirective,
    MarketPlaceComponent,
    WalletComponent,
    FeaturesComponent,
    CategoriesComponent,
    DiscoverComponent,
    TopCreatorComponent,
    ProcessComponent,
    FindjobsComponent,
    CandidatesComponent,
    BlogComponent,
    JobcategoriesComponent,
    JobFooterComponent,
    WebExternalSanitizePipe,
    PhoneFormatterPipe,
    FlagPipe,
    FilterPipe,
    PaginatePipe,
    SorterPipe,
    CurrencySymbolFormat,
    ThousandDecimalFormat,
    MandatoryFieldFormLabelPipe,
    DistanceDescriptionPipe,
    DistancePipe,
    CurrencyCompactPipe,
    TableCodePipe,
    CurrencyInputDirective,
    HasAccessDirective,
    ToTimezonePipe,
    LineBreakAtPipe
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule,
    SlickCarouselModule,
    NgbRatingModule,
    CountUpModule,
    TranslateModule
  ],
  exports: [
    BreadcrumbsComponent,
    ClientLogoComponent,
    ServicesComponent,
    CollectionComponent,
    CtaComponent,
    DesignedComponent,
    PlanComponent,
    FaqsComponent,
    LandingScrollspyDirective,
    ReviewComponent,
    CounterComponent,
    WorkProcessComponent,
    TeamComponent,
    ContactComponent,
    FooterComponent,
    ScrollspyDirective,
    WalletComponent,
    MarketPlaceComponent,
    FeaturesComponent,
    CategoriesComponent,
    DiscoverComponent,
    TopCreatorComponent,
    ProcessComponent,
    FindjobsComponent,
    CandidatesComponent,
    BlogComponent,
    JobcategoriesComponent,
    JobFooterComponent,
    WebExternalSanitizePipe,
    PhoneFormatterPipe,
    FlagPipe,
    FilterPipe,
    PaginatePipe,
    SorterPipe,
    CurrencySymbolFormat,
    ThousandDecimalFormat,
    MandatoryFieldFormLabelPipe,
    DistanceDescriptionPipe,
    DistancePipe,
    CurrencyCompactPipe,
    TableCodePipe,
    CurrencyInputDirective,
    HasAccessDirective,
    ToTimezonePipe,
    LineBreakAtPipe,
    TranslateModule,
    CommonModule,
    SlickCarouselModule,
    CountUpModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule
  ],
  providers: [
    DistanceDescriptionPipe,
    DistancePipe,
    FlagPipe,
    FilterPipe,
    PaginatePipe,
    SorterPipe,
  ],
})
export class SharedModule { }
